import type {
  NotificationOverviewCarsGetApiData,
  NotificationOverviewCarsGetApiResponses,
  NotificationOverviewMembersGetApiData,
  NotificationOverviewMembersGetApiResponses,
  NotificationOverviewSummaryGetApiData,
  NotificationOverviewSummaryGetApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

export const notificationOverviewUrls = {
  getPaginatedNotificationOverviewCars: dataEndpoint<
    NotificationOverviewCarsGetApiData,
    NotificationOverviewCarsGetApiResponses
  >({
    getUrl: ({ userGroupId, ...queryParams }) =>
      apiUrl(`user-groups/${userGroupId}/notification-overview/cars/`, queryParams)
  }),
  getPaginatedNotificationOverviewMembers: dataEndpoint<
    NotificationOverviewMembersGetApiData,
    NotificationOverviewMembersGetApiResponses
  >({
    getUrl: ({ userGroupId, ...queryParams }) =>
      apiUrl(`user-groups/${userGroupId}/notification-overview/members/`, queryParams)
  }),
  getNotificationOverviewSummary: dataEndpoint<
    NotificationOverviewSummaryGetApiData,
    NotificationOverviewSummaryGetApiResponses
  >({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/notification-overview/summary/`)
  })
};
